import i18n from '@/i18n';
import { TiktokAccountStatus } from './constant';
import { FacebookAccountStatus, GoogleAccountStatus } from './constant';
import { BmStatusEnum, StatusEnum } from './filters';

// 开户管理 - gg
// 币种
export const currencyOpenMap = ['USD', 'HKD', 'CNY'];
export const currencyOpen = [
  { label: 'USD', value: '0' },
  { label: 'HKD', value: '1' },
  { label: 'CNY', value: '2' },
];

// 需求管理
export const currencyMap = ['USD', 'HKD', 'CNY', 'ARP'];

/**
 * 除Google以外的其他需求，币种配置，用途：
 * 1. 需求的币种选择
 * 2. 需求Excel导入值校验
 *
 * text_id: 用于Excel导入值校验
 */
export const currency = [
  { label: 'USD', value: '0', text_id: 'dollar' },
  // { label: 'HKD', value: '1' },
  // { label: 'CNY', value: '2' },
  // { label: 'ARP', value: '3' },
];

/**
 * Google需求 币种配置，用途：
 * 1. Google需求的币种选择
 * 2. Google需求Excel导入值校验
 *
 * text_id: 用于Excel导入值校验
 */
export const currencyGoogle = [
  { label: 'USD', value: '0', text_id: 'dollar' },
  { label: 'HKD', value: '1', text_id: 'hkd' },
  // { label: 'CNY', value: '2', text_id: 'cny' },
  { label: 'ARP', value: '3', text_id: 'arp' },
];
// 小媒体币种
// export const smediaCurrencyMap = ['USD', 'HKD', 'CNY', 'ARP', 'JPY'];

// 这个币种map内容都是text_id，并非币种本身
export const smediaCurrencyMap = ['dollar'];
// 行业类型
export const industryMap = [
  'APP', // 0
  'EC', // 1
  'GAME', // 2
  'FIN', // 3
  'BRANDING', // 4
];

// 行业类型枚举
export enum IndustryEnum {
  // EC/Game/APP/Fin/BRANDING
  EC = 'EC',
  GAME = 'Game',
  APP = 'APP',
  FIN = 'Fin',
  BRANDING = 'BRANDING',
}
export const industryTypeMap = {
  [IndustryEnum.EC]: 'EC',
  [IndustryEnum.GAME]: 'Game',
  [IndustryEnum.APP]: 'APP',
  [IndustryEnum.FIN]: 'Fin',
  [IndustryEnum.BRANDING]: 'BRANDING',
};

// 投放区域
export const deliveryAreaMap = ['france_and_hungary', 'chinese_mainland_and_hong_kong', 'other'];

export const customerTypeMap = ['direct_customer', 'agent'];

// 开户管理 - fb
export enum OeStatusEnum {
  BF_UNDER_REVIEW = 0, // 0
  BLUEFOCUS_REJECTED, // 1
  FB_UNDER_REVIEW, // 2
  FB_REJECTED, // 3
  ACCOUNT_OPENING_COMPLETED, // 4
  CANCEL, // 5
  SUBMIT_REVIEW_TASK, // 6
}
// 开户状态
export const oeStatusMap = [
  // '等待BF审核', // 0
  // 'BF驳回', // 1
  // 'BF请求修改', // 2
  // 'BF审核通过', // 3
  // '等待FB审核', // 4
  // 'FB正在审核', // 5
  // 'FB驳回', // 6
  // 'FB请求修改', // 7
  // 'FB审核通过', // 8
  // '取消', // 9
  // '自动驳回-可上诉', // 10
  // '提交审核任务', // 11

  // 状态：BF审核中（等待BF审核）、
  // BF驳回（BF驳回、BF请求修改）、
  // FB审核中（BF审核通过、等待FB审核、FB正在审核）、
  // FB驳回（FB驳回、FB请求修改、自动驳回-可上诉）、
  // 开户完成（FB审核通过）、
  // 取消、
  // 提交审核任务
  'bf_under_review', // 0
  'bluefocus_rejected', // 1
  'fb_under_review', // 2
  'fb_rejected', // 3
  'account_opening_completed', // 4
  'cancel', // 5
  'submit_review_task', // 6
];

export const oeStatusTypeMap = {
  0: 'default',
  1: 'error',
  2: 'warning',
  3: 'success',
  4: 'default',
  5: 'processing',
  6: 'error',
  7: 'warning',
  8: 'success',
  9: 'warning',
  10: 'error',
  11: 'processing',
};

// 开户管理 - fb
// 开户状态color
export const oeStatusColorMap = {
  0: '#2961FF',
  1: '#FF5740',
  2: '#FF5740',
  3: '#2961FF',
  4: '#2961FF',
  5: '#2961FF',
  6: '#FF5740',
  7: '#FF5740',
  8: '#23C654',
  9: '#8D95AA',
  10: '#FF5740',
  11: '#FFCC27',
};

// 账户管理 - 需求申请记录
// 筛选 - 状态
export const getApplicationStatusTextMap = () => ({
  [StatusEnum.PROCESSING]: i18n.t('processing'),
  [StatusEnum.SUCCESS]: i18n.t('success'),
  [StatusEnum.FAIL]: i18n.t('fail'),
  [BmStatusEnum.MAIL_PENDING]: i18n.t('email_pending_reply'),
  [BmStatusEnum.MAIL_INVALID]: i18n.t('email_expiry'),
  [BmStatusEnum.MAIL_SENDING]: i18n.t('email_sending'),
});
export const applicationStatusColorMap = {
  [StatusEnum.PROCESSING]: 'processing',
  [StatusEnum.SUCCESS]: 'success',
  [StatusEnum.FAIL]: 'error',
  [BmStatusEnum.MAIL_PENDING]: 'processing',
  [BmStatusEnum.MAIL_INVALID]: 'error',
  [BmStatusEnum.MAIL_SENDING]: 'processing',
};

export const LIMIT_TYPE = {
  LIMIT_CHANGE: 0,
  BIND: 1,
  RENAME: 2,
  OTHER: 3,
} as const;

export const LIMIT_CHANGE_TYPE = {
  RECHARGE: 1,
  DEDUCTION: 2,
  ZEROING: 3,
} as const;

// 额度管理 类型
export const limitTypeMap = {
  1: 'recharge',
  2: 'deduction',
  3: 'zeroing',
};
// 绑定 类型
export const bindTypeMap = {
  1: 'binding',
  2: 'unbinding',
};

// MCC 类型
export const mccTypeMap = {
  1: 'accept_mcc_invitation',
  2: 'decline_mcc_invitation',
  3: 'remove_mcc',
};

// 绑定邮箱 类型
export const emailTypeMap = {
  1: 'bind_email',
  2: 'unbind_email',
};

// 绑定邮箱 权限级别
export const userRoleMap = {
  2: 'administrators',
  3: 'standard',
  4: 'read_only',
  5: 'can_only_receive_emails',
};

// 绑定BCID 权限级别
export const bindBcTypeMap = {
  1: 'administrators',
  2: 'operator',
  3: 'analyst',
};

// CID绑定邮箱时，权限级别map:
// 1: dvertiser Campaign Manager 操作者
// 2: Viewer 分析师
export const bingBindTypeMap = {
  16: 'operator',
  100: 'analyst',
};

export const accountTypeMap = {
  1: 'bidding',
  2: 'brand',
};
export const TT_SELECT_ACCOUNTTYPE = {
  BIDDING: 1,
} as const;
export const TT_SELECT_ACCOUNTTYPE_MAP = {
  [TT_SELECT_ACCOUNTTYPE.BIDDING]: 'bidding',
};

export const booleanMap = ['no', 'yes'];

export const tiktokAccountStatusMap: Record<TiktokAccountStatus, string> = {
  [TiktokAccountStatus.UNKNOWN]: 'unknown',
  [TiktokAccountStatus.NOT_PASSED]: 'failed',
  [TiktokAccountStatus.PASSED]: 'passed',
  [TiktokAccountStatus.UNDER_REVIEW]: 'under_review',
  [TiktokAccountStatus.PUNISHMENT]: 'punishing',
  [TiktokAccountStatus.DISABLED]: 'disable_tt',
  [TiktokAccountStatus.APPLY_FOR_REVIEW]: 'under_review',
  [TiktokAccountStatus.AWAIT_VALIDATION]: 'under_review',
  [TiktokAccountStatus.REVIEW_NOT_PASSED]: 'review_failed',
  [TiktokAccountStatus.REVIEW_PASSED]: 'active_tt',
  [TiktokAccountStatus.CRM_REVIEW_NOT_PASSED]: 'review_failed',
  [TiktokAccountStatus.MODIFY_APPLY_FOR_REVIEW]: 'under_review',
  [TiktokAccountStatus.MODIFY_REVIEW_NOT_PASSED]: 'review_failed',
  [TiktokAccountStatus.DEACTIVATE]: 'deactivate',
  [TiktokAccountStatus.AWAIT_CRM_REVIEW]: 'to_be_verified',
  [TiktokAccountStatus.AWAIT_PUBLIC_VALIDATION]: 'to_be_verified',
  [TiktokAccountStatus.AWAIT_QUALIFICATION_VALIDATION]: 'to_be_verified',
  [TiktokAccountStatus.CONTRACT_NOT_EFFECTIVE]: 'to_be_verified',
  [TiktokAccountStatus.IN_BAN_POOL]: 'in_ban_pool',
};


// fb gg tt 账户状态
export const accountStatusMap = {
  ...FacebookAccountStatus,
  ...GoogleAccountStatus,
  ...tiktokAccountStatusMap,
};

export const DEFAULT_INFO = '--';

export const enterTokenSeparators = ['\r\n'];

// 操作类型
export enum OperaTypeEnum {
  ADD = 'add', // 新增
  EDIT = 'edit', // 编辑
  DETAIL = 'detail', // 详情
}

// 账户ID最大长度
export const ACCOUNT_ID_MAX_LEN = 45;
// 账户名称最大长度
export const ACCOUNT_NAME_MAX_LEN = 255;
